export default __webpack_public_path__ + "static/media/loupe.e90a4a95.png";